import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { UseFormReturn } from 'react-hook-form';
import { ContactFormSchema } from './schema';

interface Props {
  form: UseFormReturn<ContactFormSchema>;
}

export const ContactFormMessageField: React.FC<Props> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="message"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Message</FormLabel>
          <FormControl>
            <Textarea placeholder="Your message" className="min-h-[100px]" {...field} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
